/**
 * The non-BernExpo confirm slider is staff-only and may only be used while the
 * lot is actually accessible: from 3h before puck-drop until 02:00 the next day
 * (client, 2026-09-17; it used to be 2h45min). Keep this in step with the API's
 * otherLotsValidity — the server refuses a confirmation outside its own window,
 * so a slider shown too early would just fail. Returns true when `gameDate`
 * falls inside that window (or when the date is missing/unparseable, so the
 * control isn't hidden by accident).
 * @param {string} gameDate ISO game start
 * @returns {boolean}
 */
export default (gameDate) => {
  if (!gameDate) return true;
  const start = new Date(gameDate);
  if (Number.isNaN(start.getTime())) return true;

  const windowStart = new Date(start.getTime() - 3 * 60 * 60 * 1000);
  const windowEnd = new Date(start.getFullYear(), start.getMonth(), start.getDate() + 1, 2, 0, 0);

  const now = new Date();
  return now >= windowStart && now < windowEnd;
};
